
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class FranchiseePayoutDialog extends Serenity.EntityDialog<FranchiseePaymentsRow, any> {
        protected getFormKey() { return FranchiseePayoutForm.formKey; }
        protected getIdProperty() { return FranchiseePaymentsRow.idProperty; }
        protected getLocalTextPrefix() { return FranchiseePaymentsRow.localTextPrefix; }
        protected getService() { return FranchiseePaymentsService.baseUrl; }

        protected form = new FranchiseePayoutForm(this.idPrefix);

        public rowids: string;
        private checkgrid: OrderFranchiseeShareCalculationGrid;
        constructor(gridToRefresh, FormMode, selectedids) {

            super();

            this.form = new FranchiseePayoutForm(this.idPrefix);
            //debugger;
            this.rowids = selectedids;

            this.form.FranchiseeId.change(e => {
                debugger;
                var vfranchiseeId = this.form.FranchiseeId.value;

                if (Q.isEmptyOrNull(vfranchiseeId)) {
                    //this.setShippingProviderDetails({});
                }
                else {
                    try {
                        debugger;
                        FranchiseePaymentsService.GetTotalShare({
                            rowIds: this.rowids,
                            //      
                        }, response => {
                            this.form.PaidAmount.value = response.PaidAmount;
                            
                        });
                    } catch (e) {

                    }
                }
            });
        }

        loadEntity(entity: FranchiseePaymentsRow) {
            //debugger;
            super.loadEntity(entity);
            //debugger;
            this.form.RowIds.value = this.rowids;
            Serenity.EditorUtils.setReadOnly(this.form.PaidAmount, true);           
        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();
            //debugger;
            buttons.splice(3, 3);


            return buttons;
        }

        onSaveSuccess(response) {
            super.onSaveSuccess(response);
            //debugger;
            if (this.form.RowIds.value != "") {
                Q.notifySuccess("Added sucessfully");
                //this.Questionsgrid.rowSelection.resetCheckedAndRefresh();
                //this.Questionsgrid.refresh();
            }

        }
    }
}